import React, { memo, forwardRef } from "react";
const Svg10PowerX = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.684 23.418c.204-.828.306-1.758.306-2.79s-.102-1.962-.306-2.79c-.192-.828-.48-1.53-.864-2.106a3.917 3.917 0 00-1.404-1.332c-.552-.312-1.188-.468-1.908-.468s-1.362.156-1.926.468a4.066 4.066 0 00-1.422 1.332c-.384.576-.678 1.278-.882 2.106-.192.828-.288 1.758-.288 2.79s.096 1.962.288 2.79c.204.828.498 1.53.882 2.106.384.576.858 1.02 1.422 1.332.564.312 1.206.468 1.926.468s1.356-.156 1.908-.468a3.917 3.917 0 001.404-1.332c.384-.576.672-1.278.864-2.106zm-1.998-4.302c.06.564.09 1.068.09 1.512 0 .444-.03.948-.09 1.512a6.623 6.623 0 01-.324 1.584 3.542 3.542 0 01-.684 1.26c-.3.336-.69.504-1.17.504-.492 0-.888-.168-1.188-.504a3.771 3.771 0 01-.702-1.26 8.048 8.048 0 01-.324-1.584 14.45 14.45 0 01-.09-1.512c0-.444.03-.948.09-1.512.06-.564.168-1.098.324-1.602.168-.504.402-.924.702-1.26.3-.348.696-.522 1.188-.522.48 0 .87.174 1.17.522.3.336.528.756.684 1.26.168.504.276 1.038.324 1.602z"
        clipRule="evenodd"
      />
      <path
        fill="#717171"
        d="M6.186 18.396l1.836-1.512v9.072c0 .252.036.462.108.63.084.156.18.276.288.36.12.084.24.138.36.162.132.036.24.054.324.054.084 0 .186-.018.306-.054a.817.817 0 00.36-.162.874.874 0 00.288-.36c.084-.168.126-.378.126-.63V15.534c0-.312-.048-.564-.144-.756a1.027 1.027 0 00-.324-.432.887.887 0 00-.432-.198 1.587 1.587 0 00-.378-.054c-.144 0-.306.036-.486.108-.168.06-.366.18-.594.36L5.016 16.83c-.192.156-.324.312-.396.468a.926.926 0 00-.108.414.927.927 0 00.936.954c.096 0 .21-.018.342-.054.132-.048.264-.12.396-.216z"
      />
      <rect width={8} height={10} x={20} y={2} fill="#DBDBDB" rx={1} />
    </svg>
  );
});
Svg10PowerX.displayName = "Svg10PowerX";
const MemoForwardRef = memo(Svg10PowerX);
export default MemoForwardRef;
